<template>
  <div class="form-elements">
    <va-card >
      <template slot="header">
        <va-icon name="fa fa-image mr-3" color="greenLight" />
        <p :style="`color: ${$themes.secondary}`">{{ $t("forms.images.imageProduct") }}</p>
      </template>
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <div class="flex md8 sm6 xs12">
            <div class="row">
              <img
                v-if="image_url"
                :src="image_url"
                class="imageCropped"
                height="100px"
                width="150px"
              />
            </div>
          </div>
        </div>
      </div>
    </va-card>
    <div class="row">
      <div class="flex xs12" :key="loop + '-3'">
        <va-card stripe="secondary">
          <template slot="header">
            <va-icon name="fa fa-product-hunt mr-2" color="greenLight" />
            <p :style="`color: ${$themes.secondary}`">{{ $t("forms.inputs.product") }}</p>
          </template>
          <form ref="form">
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-cart-plus mr-2" color="success" />
                {{ $t("forms.inputs.nameProduct") }}
                <h5 >{{ productsParams.name }}</h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-address-card-o mr-2" color="success" />
                {{ $t("forms.inputs.address") }}
                <h5>
                  <span class="px-2">
                    {{ productsParams.address }}
                  </span>
                </h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-barcode mr-2" color="success" />
                {{ $t("forms.inputs.ean") }}
                <h5>{{ productsParams.ean }}</h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-exclamation-triangle mr-2" color="success" />
                {{ $t("forms.inputs.fragility") }}
                <h5>
                  <span class="px-4">
                    {{ productsParams.fragility_id }}
                  </span>
                </h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-bars mr-2" color="success" />
                {{ $t("forms.inputs.packageline") }}
                <h5>
                  <span class="px-4">
                    {{ productsParams.product_line_id }}
                  </span>
                </h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-reorder mr-2" color="success" />
                {{ $t("forms.inputs.integrationId") }}
                <h5 >
                  <span class="px-5">
                    {{ productsParams.integration_id }}
                  </span>
                </h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-group mr-2" color="success" />
                {{ $t("forms.inputs.productFamily") }}
                <h5 >
                  <span class="px-4">
                  {{ productsParams.product_family_id }}
                  </span>
                </h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-object-group mr-2" color="success" />
                {{ $t("forms.inputs.productGroup") }}
                <h5 >
                  <span class="px-4">
                  {{ productsParams.product_group_id }}
                  </span>
                </h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-object-group mr-2" color="success" />
                {{ $t("forms.inputs.package") }}
                <h5 >
                  <span class="px-4">
                  {{ productsParams.package_id }}
                  </span>
                </h5>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-icon name="fa fa-object-group mr-2" color="success" />
                {{ $t("forms.inputs.product_type") }}
                <h5 >
                  <span class="px-4">
                  {{ productsParams.product_type_id }}
                  </span>
                </h5>
              </div>

            </div>
            <!-- end row -->
          </form>
        </va-card>

        <va-card stripe="secondary">
          <template slot="header">
            <p :style="`color: ${$themes.secondary}`"></p>
          </template>

          <div class="row">
            <div class="flex md4 sm6 xs12">
                <va-button
                v-if="this.$route.params.productSequence == true"
                medium
                inline
                color="#ff842b"
                icon="fa fa-chevron-left"
                class="ma-0"
                :to="{
                  name: 'product_sequence',
                  params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    perPage: this.$route.params.perPage,
                  },
                }"
              >
                {{ $t("menu.back_list") }}
              </va-button>
            <va-button
              v-if="this.$route.params.productSequence != true"
              medium
              inline
              color="#ff842b"
              icon="fa fa-chevron-left"
              class="ma-0"
              :to="{
                name: 'products',
                params: {
                  current_page: this.$route.params.current_page,
                  searchName: this.$route.params.searchName,
                  perPage: this.$route.params.perPage,
                },
              }"
              >
              {{ $t("menu.back_list") }}
            </va-button>
              <va-button
                medium
                inline
                color="green"
                class="ma-0"
                :to="{
                name: 'form-products',
                params: { id: this.$route.params.id,
                  current_page: current_page,
                  searchName: searchName,
                  perPage: perPage,
                },
              }"
              >
                {{ $t('menu.edit') }}
              </va-button>
            </div>
          </div>
        </va-card>

        <br />

        <!-- upload image with crop -->
      </div>
    </div>
  </div>
</template>

<script>
import ProductAPI from "@/services/ProductAPI";
import PackageAPI from "@/services/PackageAPI";

export default {
  name: "form-products",
  props: ["img"],
  data() {
    return {
      productsParams: {
        productId: "",
        name: "",
        address: "",
        ean: "",
        package_id: "",
        fragility_id: "",
        product_line_id: "",
        image_params: {},
        integration_id: "",
        product_family_id: "",
        assembly_sequence: "",
        product_group_id: "",
        product_type_id: "",
      },
      listPackages: [],
      listFragilities: [],
        full_pallet: 0,
      image: null,
      image_url: "",
      product: ""
    };
  },
  mounted() {
    if (this.$route.params.id != undefined) {
      ProductAPI.getProductById(this.$route.params.id).then((response) => {
        let res = response.data.product;

        this.productsParams.productId = res.id;
        this.productsParams.name = res.name;
        this.productsParams.address = res.address;
        this.productsParams.ean = res.ean;
        this.productsParams.package_id = res.package.name;

        if (res.fragility != null) {
          this.productsParams.fragility_id = res.fragility.name;
        }

        if (res.product_line != null) {
          this.productsParams.product_line_id = res.product_line.name;
        }

        if (res.product_family != null) {
          this.productsParams.product_family_id = res.product_family.name;
        }

        if (res.product_group != null) {
          this.productsParams.product_group_id = res.product_group.name;
        }

        if (res.product_type != null) {
          this.productsParams.product_type_id = res.product_type.name;
        }

        this.image_url = res.image;
        this.productsParams.integration_id = res.integration_id;
        this.productsParams.assembly_sequence = res.assembly_sequence;
      });
    }
  },
};
</script>
